export enum ContractInfoLevel {
  NONE,
  ORDERTYPE,
  SHIPPING_CONDITION,
  FROM,
  TO,
  INCOTERM,
  MATERIALS,
}
